import React from 'react'
import { Target, Clock, DollarSign, FileText } from 'lucide-react'

export const ProjectsReport: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
    <div className="text-center py-12">
      <Target className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
        Project Performance
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        Analyze project profitability, completion times, and material efficiency.
      </p>
    </div>
  </div>
)

export const TimeReport: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
    <div className="text-center py-12">
      <Clock className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
        Time & Labor Analysis
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        Track time efficiency, labor costs, and productivity metrics across projects.
      </p>
    </div>
  </div>
)

export const FinancialReport: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
    <div className="text-center py-12">
      <DollarSign className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
        Financial Summary
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        Comprehensive financial reports including profit/loss, cash flow, and expense analysis.
      </p>
    </div>
  </div>
)

export const TaxReport: React.FC = () => (
  <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
    <div className="text-center py-12">
      <FileText className="mx-auto h-12 w-12 text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
        Tax Reports
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        Generate tax-ready reports with FIFO cost calculations and deductible expenses.
      </p>
    </div>
  </div>
)